'use strict';

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _shared = require('./shared');

var _util = require('../util');

var _constants = require('../constants');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DEFAULT_FIELD_ID = 'user_input';
var DEFAULT_PLACEHOLDER = 'Type here...';

var styles = function styles(theme) {
  return {
    root: {
      textAlign: 'left',
      border: theme.cardBorder,
      borderRadius: 4,
      '&:focus-within': {
        boxShadow: '0 0 0 1px ' + theme.colorHighlightLabel,
        borderColor: theme.colorHighlightLabel
      }
    },
    label: {
      fontSize: 12,
      paddingLeft: 10,
      opacity: 0.75,
      position: 'relative',
      top: -3,
      fontWeight: 'bold'
    },
    input: {
      width: '100%',
      fontFamily: theme.fontPrimary,
      fontSize: theme.smallText,
      padding: 10,
      border: 0,
      background: 'transparent',
      '&:focus': {
        outline: 0
      }
    },
    textarea: {
      resize: 'vertical',
      marginBottom: -4
    }
  };
};

var TextInput = (_dec = (0, _util.withStyles)(styles), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(TextInput, _React$Component);

  function TextInput() {
    _classCallCheck(this, TextInput);

    return _possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).apply(this, arguments));
  }

  _createClass(TextInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          update = _props.update,
          config = _props.config,
          nowrap = _props.nowrap,
          classes = _props.classes;
      var fieldId = content.field_id || DEFAULT_FIELD_ID;
      var datalist = content.field_suggestions || [];
      var hasDatalist = !!datalist.length;
      var datalistId = hasDatalist ? (0, _v2["default"])() : null;
      var label = content.field_label;
      var fieldRows = content.field_rows || 1;
      var rows = hasDatalist ? 1 : fieldRows;
      var cardStyle = config.cardStyle;
      var inputProps = {
        key: content[_constants.TASK_ID],
        id: fieldId,
        placeholder: content.field_placeholder || DEFAULT_PLACEHOLDER,
        className: (0, _classnames2["default"])('prodigy-text-input', classes.input, _defineProperty({}, classes.textarea, rows > 1)),
        onChange: function onChange(event) {
          return update(_defineProperty({}, fieldId, event.target.value));
        },
        value: content[fieldId],
        autoFocus: content.field_autofocus,
        tabIndex: 1
      };
      return _react2["default"].createElement(_shared.Content, {
        cardStyle: cardStyle,
        nowrap: nowrap
      }, _react2["default"].createElement('div', {
        className: classes.root
      }, label && _react2["default"].createElement('label', {
        className: classes.label,
        htmlFor: fieldId
      }, label), rows > 1 ? _react2["default"].createElement('textarea', _extends({
        rows: rows
      }, inputProps)) : _react2["default"].createElement('input', _extends({
        type: 'text'
      }, inputProps, {
        list: datalistId
      }))), hasDatalist && _react2["default"].createElement('datalist', {
        id: datalistId
      }, datalist.map(function (opt) {
        return _react2["default"].createElement('option', {
          value: opt
        });
      })));
    }
  }]);

  return TextInput;
}(_react2["default"].Component), _class2.id = 'text_input', _temp)) || _class);
exports["default"] = TextInput;